import { launchCalendarFullCompose } from 'owa-calendar-forms-launch-handlers';

export const onNewEvent = () => {
    launchCalendarFullCompose({
        fullComposeEntrySource: 'Mail_NewItems_EventButton',
    });
};
